import React, { FC, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Input, Button, Modal, Row, Col, DatePicker, Collapse } from "antd";
import { DownOutlined, SearchOutlined } from "@ant-design/icons";
import _ from "lodash";
import "./index.scss";
import { GET_USER_INFO, UPDATE_USER_INFO } from "reducers/authReducer";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import UploadFileModal from "./UploadFileModal";
import { ReactSVG } from "react-svg";
import {
  CardElement,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";

const { Panel } = Collapse;

const SaveCardModal: FC<{ onClose: () => void; onAdd?: any }> = ({ onClose, onAdd }) => {
  const dispatch = useDispatch();
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const stripe = useStripe();
  const elements = useElements();

  const CARD_ELEMENT_OPTIONS = {
    style: {
      base: {
        color: "#32325d",
        fontSize: "16px",
        "::placeholder": {
          color: "#aab7c4",
        },
      },
      invalid: {
        color: "#fa755a",
        iconColor: "#fa755a",
      },
    },
  };

  useEffect(() => {
    // dispatch(GET_USER_INFO());
  }, []);

  const handleCancel = () => {
    // setIsModalVisible(false);
    onClose && onClose();
  };

  const handleOk = () => {
    // setIsModalVisible(false);
    onClose && onClose();
  };

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make  sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setSaving(true);

    const card = elements.getElement(CardNumberElement);
    const result = await stripe.createSource(card, { type: "card" });

    if (result.error) {
      // Show error to your customer.
      console.log(result.error.message);
    } else {
      // Send the token to your server.
      // This function does not exist yet; we will define it in the next step.
      //   stripeTokenHandler(result.token);
      console.log("source", result);
      onAdd && onAdd(result)

      // setTimeout(() => {
      //   setSaving(false);
      // }, 3000);
    }
  };

  return (
    <Modal
      // title="Edit Payment"
      title="New card"
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="480px"
      className="beam-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <form onSubmit={handleSubmit}>
        <Row className="mt-2">
          <Col span={24} className="mb-2">
            <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
          </Col>

          <Col span={24} className="mb-2">
            <CardExpiryElement options={CARD_ELEMENT_OPTIONS} />
          </Col>

          <Col span={24} className="mb-2">
            <CardCvcElement options={CARD_ELEMENT_OPTIONS} />
          </Col>
        </Row>

        <Row className="action-grp mt-4">
          <Col span={14} className="pr-2">
            <Button
              className="beam-btn green-btn cover w-full"
              htmlType="submit"
              loading={saving}
              // onClick={handleOk}
            >
              Save
            </Button>
          </Col>
          <Col span={10} className="pl-2">
            <Button
              className="beam-btn orange-btn bordered w-full"
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </form>
    </Modal>
  );
};

export default SaveCardModal;
